var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.mustShowInputComponent || _vm.isMobile,
            expression: "mustShowInputComponent || isMobile",
          },
        ],
        class: { "mobile-padding": _vm.isMobile },
      },
      [
        _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _vm.horarios.length > 0
            ? _c(
                "div",
                {
                  class: {
                    "container-horarios": true,
                  },
                },
                _vm._l(_vm.horarios, function (hora) {
                  return _c(
                    "div",
                    { key: hora.id, staticClass: "item-container" },
                    [
                      _c(
                        "div",
                        {
                          class: {
                            item: true,
                          },
                          style: {
                            "background-color":
                              hora.id === _vm.value ? " #E88A1D" : "white",
                            color: hora.id === _vm.value ? "white" : "#E88A1D",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectHora(hora.id)
                            },
                          },
                        },
                        [
                          _vm.isMobile
                            ? _c("strong", [_vm._v(_vm._s(hora.label))])
                            : _c("span", [_vm._v(_vm._s(hora.label))]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("i", [_vm._v("Nenhuma horário disponível")]),
              ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.passeioTipo === "intervalo_dias" && _vm.isMobile,
                expression: "passeioTipo === 'intervalo_dias' && isMobile",
              },
            ],
            staticStyle: { "text-align": "center" },
          },
          [_c("i", [_vm._v("Atividade para o dia todo")])]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", { staticClass: "title" }, [_vm._v("Selecione o horário")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }